import { render, staticRenderFns } from "./ButtonWithInfoText.vue?vue&type=template&id=5dd58dd0&scoped=true&"
import script from "./ButtonWithInfoText.vue?vue&type=script&lang=js&"
export * from "./ButtonWithInfoText.vue?vue&type=script&lang=js&"
import style0 from "./ButtonWithInfoText.vue?vue&type=style&index=0&id=5dd58dd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd58dd0",
  null
  
)

export default component.exports